module.exports = __webpack_public_path__ + "static/media/404-page.02b7ea57.png";